<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="printers"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="编号">
              <el-input v-model.trim="filter.no" placeholder="请输入打印机编号" clearable/>
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model.trim="filter.name" placeholder="请输入打印机名称" clearable/>
            </el-form-item>
            <el-form-item label="IP">
              <el-input v-model.trim="filter.ip" placeholder="请输入打印机IP" clearable/> 
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="filter.status" placeholder="请选择状态" clearable>
                <el-option label="在用" :value="0"/>
                <el-option label="报废" :value="1"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <printer-manage-edit ref="printerManageEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import PrinterManageEdit from "./PrinterManageEdit.vue";

  export default {
    name: "PrinterManage",
    components: { ViewTable, PrinterManageEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(82),
          editAuth: this.$auth(82),
          delAuth: this.$auth(83),
        },
        filter: {
          no: "",
          name: "",
          ip: "",
          status: "",
        },
        columnsProperty: [
          {
            key: "name",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.printerManageEdit.open(params.row, true);
                    },
                  },
                },
                params.row.name
              );
            },
          },
          {
            key: "ip",
            align: "center",
          },
          {
            key: "status",
            width: 160,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: params.row.status === 0 ? "#67c23a" : "#909399",
                  },
                },
                params.row.status === 0 ? "在用" : "报废"
              );
            },
          },
          {
            key: "no",
            width: 180,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      addEditHandle(row) {
        this.$refs.printerManageEdit.open(row);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "printers", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
